export default __webpack_public_path__ + "static/media/dice-6.ba12c1ad.svg";